const EPS_COLORS = {
  amethyst: ['#8d718f', '#fff'], banana: ['#f1dc82', '#1d1e19'], bay: ['#9cae9d', '#1d1e19'],
  berry: ['#9b4f68', '#fff'], black: ['#252525', '#fff'], blossom: ['#e8b8bd', '#1d1e19'],
  'blue jean': ['#6f8998', '#fff'], boysenberry: ['#75455d', '#fff'], brick: ['#9c5546', '#fff'],
  'bright salmon': ['#ef786d', '#1d1e19'], 'burnt orange': ['#b65f35', '#fff'], butter: ['#efe0a4', '#1d1e19'],
  'chalky mint': ['#abc7b1', '#1d1e19'], chambray: ['#9bb6c4', '#1d1e19'], chili: ['#a84739', '#fff'],
  'china blue': ['#607d91', '#fff'], citrus: ['#d4d562', '#1d1e19'], crimson: ['#9f3340', '#fff'],
  crunchberry: ['#cf5d81', '#fff'], denim: ['#4f6d7c', '#fff'], emerald: ['#2f715e', '#fff'],
  espresso: ['#4b3830', '#fff'], 'flo blue': ['#4d8fa9', '#fff'], granite: ['#777875', '#fff'],
  grape: ['#6d5578', '#fff'], grass: ['#659557', '#fff'], grey: ['#8f9290', '#1d1e19'],
  gray: ['#8f9290', '#1d1e19'], hemp: ['#aa9b78', '#1d1e19'], hydrangea: ['#8198bc', '#fff'],
  'ice blue': ['#bfd5d6', '#1d1e19'], ivory: ['#eee9d7', '#1d1e19'], khaki: ['#9b9574', '#1d1e19'],
  'lagoon blue': ['#4b8992', '#fff'], 'light green': ['#a8c49b', '#1d1e19'], melon: ['#e5967e', '#1d1e19'],
  midnight: ['#263442', '#fff'], moss: ['#596247', '#fff'], mustard: ['#c3993e', '#1d1e19'],
  navy: ['#26364a', '#fff'], 'neon blue': ['#278dc2', '#fff'], 'neon pink': ['#ec5a93', '#1d1e19'],
  'neon red orange': ['#f05d45', '#1d1e19'], orchid: ['#b58bad', '#1d1e19'], paprika: ['#b45b45', '#fff'],
  pepper: ['#4b4d4c', '#fff'], periwinkle: ['#8f9ec7', '#1d1e19'], red: ['#ad3e3d', '#fff'],
  'royal caribe': ['#2f8d9f', '#fff'], sage: ['#95a087', '#1d1e19'], sandstone: ['#b5a58b', '#1d1e19'],
  sapphire: ['#286b8b', '#fff'], seafoam: ['#9fc8bd', '#1d1e19'], 'stonewashed blue': ['#6f8490', '#fff'],
  terracotta: ['#b86d57', '#fff'], 'topaz blue': ['#3f7f95', '#fff'], 'true navy': ['#222f43', '#fff'],
  violet: ['#735f91', '#fff'], watermelon: ['#d76470', '#fff'], white: ['#faf9f4', '#1d1e19'],
  yam: ['#cb6f3f', '#1d1e19']
};

function normalizeColor(value) {
  return value.trim().toLowerCase().replace(/[_-]+/g, ' ').replace(/\s+/g, ' ');
}

function enhanceColorSelectors(root = document) {
  root.querySelectorAll('variant-picker fieldset.variant-option--buttons').forEach((fieldset) => {
    const legend = fieldset.querySelector('legend');
    if (!legend || !/^colou?r\b/i.test(legend.textContent.trim())) return;
    fieldset.classList.add('variant-option--eps-colors');
    const selectedInput = fieldset.querySelector('input[type="radio"]:checked');
    const selectedColor = selectedInput?.value || fieldset.querySelector('input[type="radio"]')?.value || '';

    const legendLabel = legend.querySelector('span');
    if (legendLabel) {
      const baseLabel = legend.dataset.epsColorLabel || legendLabel.textContent.split(':')[0].trim() || 'Color';
      legend.dataset.epsColorLabel = baseLabel;
      legendLabel.textContent = baseLabel;
    }

    fieldset.querySelectorAll('.variant-option__button-label').forEach((label) => {
      const input = label.querySelector('input[type="radio"]');
      if (!input) return;
      const [color, ink] = EPS_COLORS[normalizeColor(input.value)] || ['#d9d5ca', '#1d1e19'];
      label.title = input.value;
      label.dataset.epsTooltip = input.value;
      label.style.setProperty('--eps-swatch', color);
      label.style.setProperty('--eps-swatch-ink', ink);
      label.style.setProperty('--eps-swatch-border', ink === '#fff' ? 'rgba(255,255,255,.48)' : 'rgba(29,30,25,.32)');
    });
  });
}

function bindSizeGuide() {
  const dialog = document.getElementById('EpsSizeGuide');
  if (!dialog) return;

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-eps-size-guide-open]');
    if (openButton) {
      dialog.showModal();
      return;
    }

    if (event.target.closest('[data-eps-size-guide-close]')) dialog.close();

    const unitButton = event.target.closest('[data-eps-size-unit]');
    if (unitButton) {
      const unit = unitButton.dataset.epsSizeUnit;
      dialog.querySelectorAll('[data-eps-size-unit]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button === unitButton));
      });
      dialog.querySelectorAll('[data-eps-size-table]').forEach((table) => {
        table.hidden = table.dataset.epsSizeTable !== unit;
      });
      dialog.querySelectorAll('[data-eps-size-note]').forEach((note) => {
        note.hidden = note.dataset.epsSizeNote !== unit;
      });
    }
  });

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) dialog.close();
  });
}

function placeAboutImages() {
  const media = document.querySelector('[data-eps-about-media]');
  if (!media) return;
  const article = media.closest('.section-content-wrapper')?.querySelector('.rte');
  if (!article) return;
  const figures = [...media.querySelectorAll('.eps-about-figure')];
  const headings = [...article.querySelectorAll('h2')];
  if (figures[0] && headings[0]) headings[0].before(figures[0]);
  if (figures[1] && headings[3]) headings[3].before(figures[1]);
  media.remove();
}

function manageEmailSignupVisibility() {
  const homepageSignup = document.querySelector('.eps-newsletter');
  const footerSignupSections = [...document.querySelectorAll('.email-signup-block')]
    .map((signup) => signup.closest('.shopify-section'))
    .filter(Boolean);

  if (homepageSignup) {
    footerSignupSections.forEach((section) => {
      section.hidden = true;
    });
  }

  const success = document.querySelector('[data-eps-signup-success]');

  if (success) {
    try {
      localStorage.setItem('eps_email_subscribed', '1');
    } catch (error) {
      return;
    }
    return;
  }

  let hasSubscribed = false;
  try {
    hasSubscribed = localStorage.getItem('eps_email_subscribed') === '1';
  } catch (error) {
    return;
  }

  if (!hasSubscribed) return;

  if (homepageSignup) homepageSignup.hidden = true;

  footerSignupSections.forEach((section) => {
    section.hidden = true;
  });
}

function initializeEpsUx(root = document) {
  enhanceColorSelectors(root);
  placeAboutImages();
  manageEmailSignupVisibility();
}

initializeEpsUx();
bindSizeGuide();

document.addEventListener('change', (event) => {
  const input = event.target.closest('fieldset.variant-option--eps-colors input[type="radio"]');
  if (!input) return;
  requestAnimationFrame(() => enhanceColorSelectors(document));
  window.setTimeout(() => enhanceColorSelectors(document), 150);
});

document.addEventListener('shopify:product:select', (event) => {
  if (!event.promise || typeof event.promise.then !== 'function') return;

  event.promise.then(
    () => requestAnimationFrame(() => enhanceColorSelectors(document)),
    () => requestAnimationFrame(() => enhanceColorSelectors(document))
  );
});

new MutationObserver((mutations) => {
  let hasVariantUpdate = false;
  const variantSelector = 'variant-picker, fieldset.variant-option--buttons, .variant-option__button-label, input[type="radio"][data-option-name]';

  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node instanceof Element && (node.matches(variantSelector) || node.querySelector(variantSelector))) {
        hasVariantUpdate = true;
      }
    }
  }
  if (hasVariantUpdate) requestAnimationFrame(() => enhanceColorSelectors(document));
}).observe(document.documentElement, { childList: true, subtree: true });
